import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import {
    FormGroup,
    Input,
    Button,
    Label,
    Form,
    InputGroup,
    InputGroupAddon
} from "reactstrap"

import { HeaderAuth } from "../../components/AppInfo/HeaderAuth";
import { FooterAuth } from "../../components/AppInfo/FooterAuth";
import EmptyLayout from '../../components/EmptyLayout';
import { ThemeConsumer } from '../../components/Theme';

const Error404 = () => (
    <EmptyLayout>
        <EmptyLayout.Section center>
            { /* START Header */}
            <HeaderAuth 
                title="Error 404"
            />
            { /* END Header */}
            { /* START Form */}
            <Form className="mb-3">
                <FormGroup>
                    <Label for="search">
                        Search
                    </Label>
                    <InputGroup>
                        <Input type="text" name="text" id="search" placeholder="Enter search phrase here..." className="bg-white" />
                        <InputGroupAddon addonType="append">
                            <ThemeConsumer>
                            {
                                ({ color }) => (
                                    <Button color={ color } tag={ Link } to="/">
                                        <i className="fa fa-search"></i>
                                    </Button>
                                )
                            }
                            </ThemeConsumer>
                        </InputGroupAddon>
                    </InputGroup>
                </FormGroup>
            </Form>
            { /* END Form */}
            { /* START Bottom Links */}
            <div className="d-flex mb-5">
                <Link to="/dashboards/system">
                    Back to Home
                </Link>
            </div>
            { /* END Bottom Links */}
            { /* START Footer */}
            <FooterAuth />
            { /* END Footer */}
        </EmptyLayout.Section>
    </EmptyLayout>
);

export default Error404;
